import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ClassesReportModel, ClassReportModel, ContextModel } from '@bayclubs/group-classes-employee-api';
import { TranslateService } from '@ngx-translate/core';
import { ClubCentricClassItem, ClubCentricClubSummaryItem, ClubCentricFilters } from '../../models/club-centric-report-model';
import { ReportFilter, ReportType } from '../../models/reports-model';
import { ReportSelectService } from '../../services/report-select.service';
import { ReportsService } from '../../services/reports.service';
import { BaseReportComponent } from '../base/base-report.component';
@Component({
    selector: 'app-club-centric-report',
    templateUrl: './club-centric-report.component.html',
    styleUrls: ['./club-centric-report.component.scss'],
    standalone: false
})
export class ClubCentricReportComponent extends BaseReportComponent implements OnInit, OnDestroy {
    reportData: ClubCentricClubSummaryItem[];
    loadedReportData: ClubCentricClubSummaryItem[];
    backendData: ClassReportModel[];

    public context: ContextModel;
    constructor(
        activatedRoute: ActivatedRoute,
        reportSelectService: ReportSelectService,
        reportsService: ReportsService,
        translateService: TranslateService
    ) {
        super(activatedRoute, reportSelectService, reportsService, translateService);
    }

    ngOnInit() {
        this.reportType = ReportType.ClubCentricReport;
        super.ngOnInit();
        this.reportData = [];
        this.loadedReportData = [];
        this.displayedClasses = [];
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    filterClass(filter: ClubCentricFilters) {
        if (filter.instructors) {
            this.loadSelectedClasses(this.backendData, filter.instructors);
            if (filter.className && this.displayedClasses.filter(p => p.name === filter.className).length === 0) {
                filter.className = null;
            }
        }
        this.reportData = this.loadedReportData
            .map(data => {
                let accept = true;
                if (filter.className) {
                    if (data.classes.filter(p => p.className === filter.className).length > 0) {
                        accept = true;
                    } else {
                        accept = false;
                    }
                }
                if (filter.instructors) {
                    if (data.classes.filter(p => filter.instructors.includes(p.instructorId)).length > 0) {
                        accept = true;
                    } else {
                        accept = false;
                    }
                }
                if (accept) {
                    return this.generateSummaryRow(data, filter.className, filter.instructors);
                }
            })
            .filter(p => p !== undefined);
    }

    private generateSummaryRow(data: ClubCentricClubSummaryItem, className: string, instructors: string[]) {
        const retData = new ClubCentricClubSummaryItem(data.clubId, data.clubName, data.clubShortName);
        retData.classes = data.classes;
        if (instructors) {
            retData.classes = retData.classes.filter(p => instructors.includes(p.instructorId));
        }
        if (className) {
            retData.classes = retData.classes.filter(p => p.className === className);
        }
        retData.totalCost = this.calculateSummaryRowTotalCost(retData.classes);
        retData.totalHours = this.calculateSummaryRowTotalHours(retData.classes);
        return retData;
    }

    showReport(filter: ReportFilter) {
        if (filter === null) {
            this.generateDisabled = true;
            this.loadedReportData = [];
            this.reportData = [];
        } else {
            this.subscriptions.add(
                this.reportsService.getClubCentricReportData(filter).subscribe((value: ClassesReportModel) => {
                    if (value.groupClasses !== null) {
                        this.backendData = value.groupClasses;
                        this.generateReportData(value.groupClasses);
                        this.loadSelectedClasses(value.groupClasses, null);
                        this.loadSelectedInstructors(value.groupClasses);
                        if (this.reportData.length > 0) {
                            this.generateDisabled = false;
                        }
                    }
                })
            );
        }
    }

    generateReportFile(filter: ReportFilter) {
        this.subscriptions.add(
            this.reportsService.generateClubCentricReportFile(filter).subscribe(value => {
                this.downloadReportFile(value, 'clubCentricReport_');
            })
        );
    }

    private generateReportData(groupClasses: ClassReportModel[]) {
        let data: ClubCentricClubSummaryItem[] = [];
  
        groupClasses.forEach(groupClass => {
            let summaryItem = data.find(p => p.clubId === groupClass.clubId);
            if (summaryItem === undefined) {
                const club = this.context.clubs.find(c => c.id === groupClass.clubId);
                summaryItem = new ClubCentricClubSummaryItem(groupClass.clubId, groupClass.clubName, groupClass.clubShortName);
                data.push(summaryItem);
            }
            const centricItem = new ClubCentricClassItem();
            this.fillClassItem(groupClass, centricItem);
            centricItem.instructor = groupClass.instructorName;
            centricItem.instructorId = groupClass.instructorId;
            summaryItem.classes.push(centricItem);
        });
        data = this.calculateAndSortData(data);
        this.reportData = data;
        this.loadedReportData = [...data];
    }
    private calculateAndSortData(data: ClubCentricClubSummaryItem[]): ClubCentricClubSummaryItem[] {
        return data.map(item => {
            item.totalHours = this.calculateSummaryRowTotalHours(item.classes);
            item.totalCost = this.calculateSummaryRowTotalCost(item.classes);
            item.classes = this.sort(item.classes, [{ date: 'asc', startTime: 'asc' }]);
            return item;
        });
    }
}
